exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageContent[data-v-8d8ae5da]{max-width:800px;line-height:1.375}.pageTitle[data-v-8d8ae5da]{max-width:340px}.pageSubtitle[data-v-8d8ae5da]{max-width:415px}.font-18px[data-v-8d8ae5da]{font-size:18px}.icon[data-v-8d8ae5da]{display:flex;place-items:center;font-size:27px;color:#a7a7a7;padding-left:70px}@media(max-width: 768px){.icon[data-v-8d8ae5da]{padding-left:20px}}.options[data-v-8d8ae5da]{display:grid;grid-template-columns:1fr 1fr;grid-column-gap:1rem}@media(max-width: 768px){.options[data-v-8d8ae5da]{display:block}}", ""]);

// exports
